import { useState } from 'react'
import { useLanguage } from '../contexts/LanguageContext'
import { ColoringGame } from './ColoringGame'
import { ContactForm } from './ContactForm'
import './ColoringGame.css'

export function CareersPageSection({ contactFormProps, onCareersSubmit }) {
  const { t } = useLanguage()
  const [colorGameOpen, setColorGameOpen] = useState(false)

  return (
    <section
      id="careers"
      className="section contact section-contact--redesign section-careers section-careers--page"
      aria-labelledby="careers-page-heading"
    >
      <div className="contact-redesign__inner">
        <div className="contact-redesign__info">
          <span className="pricing-section-eyebrow">{t('careers.eyebrow')}</span>
          <h1 id="careers-page-heading" className="contact-redesign__title contact-redesign__title--page">
            {t('careers.title')}
          </h1>
          <p className="contact-redesign__subtitle">{t('careers.subtitle')}</p>
          <button type="button" className="careers-color-game-btn" onClick={() => setColorGameOpen(true)}>
            Color game
          </button>
          <p className="contact-redesign__subtitle contact-redesign__subtitle--roles">{t('careers.rolesHeading')}</p>
          <ul className="contact-redesign__meta contact-redesign__roles-list">
            <li>{t('careers.roleEngineering')}</li>
            <li>{t('careers.roleSupport')}</li>
            <li>{t('careers.roleMarketing')}</li>
            <li>{t('careers.roleSeo')}</li>
            <li>{t('careers.roleProduct')}</li>
            <li>{t('careers.roleOps')}</li>
          </ul>
          <p className="contact-redesign__subtitle">{t('careers.howToApply')}</p>
          <div className="contact-redesign__trust">
            <span className="contact-redesign__trust-badge">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden><polyline points="20 6 9 17 4 12"/></svg>
              {t('careers.trustConfidential')}
            </span>
            <span className="contact-redesign__trust-badge">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden><polyline points="20 6 9 17 4 12"/></svg>
              {t('careers.trustResume')}
            </span>
          </div>
        </div>
        <div className="contact-redesign__form">
          <div className="contact-card contact-card--modern">
            <ContactForm
              {...contactFormProps}
              messagePlaceholder={t('careers.placeholderMessage')}
              attachmentsHint={t('careers.attachmentsHint')}
              submitLabel={t('careers.sendApplication')}
              onSubmit={onCareersSubmit}
            />
          </div>
        </div>
      </div>
      {colorGameOpen ? <ColoringGame onClose={() => setColorGameOpen(false)} /> : null}
    </section>
  )
}
